import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useThemeContext } from '../../contexts/ThemeContext'; // Ajuste o path conforme necessário
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

export const ThemeToggle = () => {
    const { mode, toggleTheme } = useThemeContext();

    return (
        <Tooltip title={mode === 'dark' ? "Mudar para Modo Claro" : "Mudar para Modo Escuro"}>
            <IconButton
                onClick={toggleTheme}
                color="inherit"
                sx={{
                    transition: 'transform 0.3s ease',
                    '&:hover': { transform: 'rotate(15deg)' }
                }}
            >
                {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Tooltip>
    );
};
